
import React, { useRef, useEffect } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import MarkdownRenderer from "@/components/MarkdownRenderer";

interface ChangelogSectionProps {
  registerSectionRef: (id: string, element: HTMLElement | null) => void;
}

const changelogMarkdown = `
## April 25, 2025
- Added CSV Import/Export functionality for leads
  - Support for bulk lead imports with status notes
  - Full data export capabilities
  - Improved error reporting
  - Template download option

## April 20, 2025
- Initial platform release
  - Core lead management features
  - Company management system
  - User roles and permissions
  - Basic dashboard analytics
`;

const ChangelogSection = ({ registerSectionRef }: ChangelogSectionProps) => {
  const recentChangesRef = useRef<HTMLHeadingElement>(null);
  
  useEffect(() => {
    registerSectionRef('recent-changes', recentChangesRef.current);
  }, [registerSectionRef]);

  return (
    <>
      <h2 
        id="recent-changes" 
        ref={recentChangesRef}
        className="text-2xl font-bold tracking-tight scroll-mt-16"
      >
        Recent Changes
      </h2>
      <Card>
        <CardHeader>
          <CardTitle>Platform Updates</CardTitle>
          <CardDescription>Track changes and new features in Discovery Hub</CardDescription>
        </CardHeader>
        <CardContent>
          <MarkdownRenderer content={changelogMarkdown} />
        </CardContent>
      </Card>
    </>
  );
};

export default ChangelogSection;
